module.exports = __webpack_public_path__ + "media/newstyle/images/blogger-round-svgrepo-com-a3eff61fb91ed6b790ed340f2205b818.svg";